import { useEffect, useState, useContext, useMemo } from "react";
import { ProductsContext } from "../../contexts/ProductsContext";
import ProductCard from "../product-card";
import ProductCardSkeleton from "../product-card-skeleton/product-card-skeleton";
import ErrorMessage from "../error-message";
import "./product-cards.css";

function ProductCards({
  countCards,
  groupsID,
  excludeID = null,
  random = true,
  brandName = null,
  cards = null,
}) {
  const { getProductsForGroups } = useContext(ProductsContext);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let isMounted = true;

    async function loadCars() {
      if (cards && Array.isArray(cards)) {
        setCars(cards);
        setError(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setCars([]);
      setError(null);

      try {
        const groupIds = Array.isArray(groupsID) ? groupsID : [];
        const cacheKey = `app-cards:${[...groupIds].sort((a, b) => a - b).join(",") || "empty"}`;
        const merged = await getProductsForGroups(groupIds, { cacheKey });

        if (!isMounted) return;

        const filtered = merged
          .filter((car) => (excludeID ? car.id !== excludeID : true))
          .filter((car) =>
            brandName ? car.brand__polnoe_nazvanie === brandName : true,
          );

        setCars(filtered);
      } catch (error) {
        if (!isMounted) return;
        console.error("Error loading cards:", error);
        setCars([]);
        setError(error?.message || "Не удалось загрузить список товаров");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadCars();

    return () => {
      isMounted = false;
    };
  }, [groupsID, excludeID, brandName, cards, getProductsForGroups, retryCount]);

  // Select with the data so the grid never renders empty between loading states.
  const carsInStock = useMemo(() => {
    const selected = [...cars];
    if (random) {
      for (let index = selected.length - 1; index > 0; index -= 1) {
        const next = Math.floor(Math.random() * (index + 1));
        [selected[index], selected[next]] = [selected[next], selected[index]];
      }
    }
    return selected.slice(0, countCards || selected.length);
  }, [cars, countCards, random]);

  if (loading) {
    return (
      <div className="cars">
        {Array.from({ length: countCards || 4 }).map((_, index) => (
          <ProductCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <ErrorMessage
        title="Ошибка загрузки товаров"
        message={error}
        actionLabel="Повторить"
        onAction={() => setRetryCount((prev) => prev + 1)}
        className="cars-error"
      />
    );
  }

  return (
    <div className="cars">
      {carsInStock.map((item, key) => (
        <ProductCard
          key={`${item.first_id}-${key}`}
          id={item.first_id}
          title={item.title_store}
          pictId={item.main_photo}
          price={item.rekomend_cena_za_ed}
        />
      ))}
    </div>
  );
}

export default ProductCards;
